import { defaultI18nNs } from '@cocoonspace/shared/config/default-i-18-n-ns-config'
import type { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import { DashboardPage } from '~/domains/account/components/dashboard/dashboard'

export default DashboardPage

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
	props: {
		...(await serverSideTranslations(locale as string, [
			...defaultI18nNs,
			'cwDashboard',
			'myEvents',
			'myAccountCoupons',
			'extras',
			'booking',
			'space',
		])),
	},
})
